import * as React from "react";
import {authorize, Overlay} from "@athena-portal/components";
import {PluginTemplates} from "../../../../../utils/PluginTemplates";
import FalconFooter from "../../../../../components/navigation/FalconFooter";
import FalconHeader from "../../../../../components/navigation/FalconHeader";
import {RouteComponentProps} from "react-router";
import {deleteSessionStorage, getSessionStorage} from "../../../../../CommonFunctions";
import {OnlineMotorClaimRequest} from "@falcon/services";
import {BackButton} from "../../../../../components/navigation/BackButton";
import {ClaimSubmissionPanel} from "../../../../../components/claims/ClaimSubmissionPanel";

interface IProps extends RouteComponentProps<{}> {
    location: any;
}

interface IClaimSubmittedPageState {
    onlineMotorClaimRequest: OnlineMotorClaimRequest;
    showOverlay: boolean | null;
}

@authorize
export class AnnualMotorClaimSubmittedPage extends React.Component<IProps, IClaimSubmittedPageState> {

    private pluginTemplates = new PluginTemplates();

    constructor(props: IProps) {
        super(props);
        const onlineMotorClaimRequest: OnlineMotorClaimRequest = getSessionStorage("onlineMotorClaimRequest");

        this.state = {
            onlineMotorClaimRequest: onlineMotorClaimRequest !== null ? onlineMotorClaimRequest : new OnlineMotorClaimRequest(),
            showOverlay: (this.props.location.state && this.props.location.state.showOverlay) ? this.props.location.state.showOverlay : false
        }
    }

    public componentDidMount(): void {
        window.scrollTo(0, 0);
        this.pluginTemplates.setPageTitle("Make a car claim");
        window.addEventListener("beforeunload", this.clearSession);
        this.setState({showOverlay: false});
    }

    public componentWillUnmount() {
        window.removeEventListener("beforeunload", this.clearSession);
        this.clearSession();
    }

    public render() {
        if (!this.state.showOverlay) {
            return (
                <React.Fragment>
                    <FalconHeader/>

                    <div className="page-contents text-center">
                        <BackButton isTop={true} link={"/dashboard/"} />
                        <ClaimSubmissionPanel onlineClaimRequest={this.state.onlineMotorClaimRequest} showUrgentClaimSection={true} />
                        <BackButton isTop={false} link={"/dashboard/"} />
                    </div>

                    <FalconFooter/>
                </React.Fragment>
            );
        } else {
            return (<Overlay show={true}/>)
        }
    }

    private clearSession = (): void => {
        deleteSessionStorage("onlineMotorClaimRequest");
    };
}



// WEBPACK FOOTER //
// ./src/pages/dashboard/annual/motor/claims/AnnualMotorClaimSubmittedPage.tsx